import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useSelector, useDispatch } from "react-redux";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import { getPermissions } from 'api/UsersApi'
import SupportLink from "../Common/SupportLink";
import {exportUsers} from 'api/ExportApi'

import { getAllUsers, putUser, getUserscount } from "api/UsersApi";
import Table from "../Table";
import ContantLoader from "views/ContantLoader";
var offSet = 0;
var matchNextButton = 1;

const AllUsers = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [createUserPermission, setCreateUserPermission] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);


  const searchText = useRef("");

  const { companyUserLoading } = useSelector(
    (state) => state.companyUserSetter
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCompanyUserLoading(true));
    getPermissions().then(res => {
      // 
      setCreateUserPermission(!res['CreateUser'].allowed);
      setPermissionMessage(res['CreateUser'].message);
    })
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setCompanyUserLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    searchText.current.value !== ""
      ? await getUserscount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })
        .catch((e) => { })
      : await getUserscount()
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })
        .catch((e) => { })

    searchText.current?.value !== ""
      ? await getAllUsers(pageSize, startRow, searchText.current?.value)
        .then((data) => {
          setDataApi(data);
          dispatch(setCompanyUserLoading(false));
        })
        .catch((e) => { })
      : await getAllUsers(pageSize, startRow)
        .then((data) => {
          setDataApi(data);
          dispatch(setCompanyUserLoading(false));
        })
        .catch((e) => { })
  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "Role",
        accessor: "role",
      },
      {
        // width: 300,
        Header: "Status",
        accessor: "",
        Cell: ({ cell }) => (
          <div className="custom-control custom-switch d-flex justify-content-center">
            <input
              type="checkbox"
              className="custom-control-input"
              id={"customSwitch1" + cell.row.original.id}
              onClick={(e) => {
                cell.row.original.status == "inactive"
                  ? activate(cell.row.original.id, true)
                  : activate(cell.row.original.id, false);
              }}
              checked={cell.row.original.status == "active" ? true : false}
            ></input>
            <label
              className="custom-control-label"
              for={"customSwitch1" + cell.row.original.id}
            ></label>
          </div>
        ),
      },
      {
        // width: 300,
        Header: "Actions",
        accessor: "",
        Cell: ({ cell }) => (

          (
            <div className="workflow_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Edit User
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.history.push(
                      `/admin/users/create`,
                      cell.row.original
                    );
                  }}
                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },
    ],
    [dataApi]
  );

  const activate = (id, is) => {

    var status;
    if (is) status = "active";
    else status = "inactive";
    var data = {
      status: status,
    };
    putUser(id, data)
      .then((res_data) => {
        // getAllUsers(offSet)
        //   .then((data) => {
        let temp = [...dataApi];
        var x = temp.find((u) => {
          return u.id == id;
        });
        x.status = status;
        setDataApi(temp);
        // })
        // .catch((e) => 
      })
      .catch((e) => { })
  };
  const createUser = () => {
    props.history.push(`/admin/users/create`);
  };

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>

          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }

  return (
    <Container>
      {messageBar(permissionMessage)}
      <SupportLink link='https://kapitalwise.com/user-guide/settings#user_setup' />

    
    <div className="top-header-cont">
    
      <div className="page_heading" style={{ display: "flex" }}>
        <div style={{ flex: "1" }}>
          <h2>Users List</h2>

          <p className="sm d-flex align-items-center">
            You have {total} Users.
          </p>
        </div>




      </div>




      <div className="joifo">

      <div className="search_bar_wrap d-flex">
            {/* <label className="search_label mr-3">Search</label> */}
            <input
              className="form-control search-input"
              id="search_input"
              placeholder="Enter Name or Description "
              ref={searchText}
              style={{ maxWidth: "23%", marginLeft: "25px" }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  dispatch(setCompanyUserLoading(true));
                  fetchData({
                    pageSize: 10,
                    pageIndex: 0,
                    searchText: searchText.current.value,
                  })
                    .then(() => {
                      dispatch(setCompanyUserLoading(false));
                    })
                    .catch((e) => { })
                }
              }}
            />
            <button
              onClick={() => {
                dispatch(setCompanyUserLoading(true));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  searchText: searchText.current.value,
                })
                  .then(() => {
                    dispatch(setCompanyUserLoading(false));
                  })
                  .catch((e) => { })
              }}
              className="lg_btn tertiary search_btn"
              style={{ height: "38px", margin: "0 0 1vh 1vh" }}
            >
              {companyUserLoading ? "Loading..." : "Search"}
            </button>
          </div>

      
      <div class="separator-vert"> </div>
      <div style={{ }}>
          <input
            onClick={exportUsers}
            type="submit"
            name="Save"
      
            className="add__stage lg_btn primary"
            value="Export"
          />          
          <input
            onClick={createUser}
            type="submit"
            name="Save"
            style={createUserPermission ? {

              cursor: 'not-allowed'
            } : {
 
            }}
            className="add__stage lg_btn primary"
            value="New User"
            disabled={createUserPermission}
          />
        </div>


    </div>

    </div>




      <div></div>
      {dataApi ? (
        <div className="dataTableOuter">
       
          <div className="table-flter rdt_Pagination d-flex align-items-center">
            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          {
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={companyUserLoading}
            ></Table>
          }
        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
  );
};

export default AllUsers;
